// Display name of the embedded LLM assistant. Used in every user-facing
// place that mentions the assistant by name (headings, tooltips, aria
// labels, message-bubble role label, greeting). Internal identifiers
// (file/dir names, DB table/column names, tRPC routes, log lines)
// continue to use "assistant" — this constant is purely cosmetic.
export const ASSISTANT_NAME = 'Marvin'
